import { getMessageFromError } from '../utils/functions'
import featureFlags from '@/config/featureFlags'

const PREFIX = 'admin/gurudwara-service'
export default {
  /* -------------------------------------------------------------------------- */
  /*                                   Create                                   */
  /* -------------------------------------------------------------------------- */
  async create({ commit }, data) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.post(`${PREFIX}/create`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      // Manage Error
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },
  /* -------------------------------------------------------------------------- */
  /*                                    List                                    */
  /* -------------------------------------------------------------------------- */
  async get({ commit }, params) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${PREFIX}/list`, { params })
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'records',
        data: res.data.data.results
      })
      commit('SET_STATE', {
        action: 'total',
        data: res.data.data.totalResults
      })
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.data.totalResults
      })
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  async delete({ commit }, id) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.delete(`${PREFIX}/delete/${id}`)
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  async update({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.put(`${PREFIX}/update/${id}`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  async show({ commit }, id) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${PREFIX}/${id}`)
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'record',
        data: res.data.data
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  async updateStatus({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.put(`${PREFIX}/status/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATUS', { id, status: res.data.data.is_active })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },
  
  /* -------------------------------------------------------------------------- */
  /*                    Get Available Time Slots For A Service                   */
  /* -------------------------------------------------------------------------- */
  async getAvailableTimeSlots({ commit }, { gurudwara_service_id, date }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const params = { gurudwara_service_id, date } 
      const res = await this.$http.get(`admin/gurudwara-service-booking/time-slots/available`, { params })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },
  
  /* -------------------------------------------------------------------------- */
  /*                        Booking List for Slot Master                         */
  /* -------------------------------------------------------------------------- */
  async getBookings({ commit }, params) {
    commit('SET_STATE', {
      action: 'bookingListLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`admin/gurudwara-service-booking/list`, { params })
      commit('SET_STATE', { action: 'bookingListLoading', data: false })
      commit('SET_STATE', { action: 'bookingRecords', data: res.data.data.results })
      commit('SET_STATE', { action: 'bookingTotal', data: res.data.data.totalResults })
      commit('SET_STATE', { action: 'bookingFilteredCount', data: res.data.data.totalResults })
      return { data: res.data.data }
    } catch (error) {
      commit('SET_STATE', { action: 'bookingListLoading', data: false })
      const { message } = getMessageFromError(error)
      return Promise.reject({ message })
    }
  },
  async getBookingCounts({ commit }, params = {}) {
    try {
      const res = await this.$http.get(`admin/gurudwara-service-booking/bookings-counts`, { params })
      commit('SET_STATE', { action: 'bookingCounts', data: res.data && res.data.data ? res.data.data : {} })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      const { message } = getMessageFromError(error)
      return Promise.reject({ message })
    }
  },
  /* -------------------------------------------------------------------------- */
  /*                    Update Booking Status                                   */
  /* -------------------------------------------------------------------------- */
  async updateBookingStatus({ commit }, { id, booking_status, rejection_reason, admin_notes, prasad_status, payment_status, mark_payment_received }) {
    commit('SET_STATE', { action: 'loading', data: true })
    try {
      const payload = {}
      if (booking_status) payload.booking_status = booking_status
      if (rejection_reason) payload.rejection_reason = rejection_reason
      if (admin_notes) payload.admin_notes = admin_notes
      if (prasad_status) payload.prasad_status = prasad_status
      if (payment_status) payload.payment_status = payment_status
      if (mark_payment_received) payload.mark_payment_received = true
      const res = await this.$http.put(`admin/gurudwara-service-booking/status/${id}`, payload)
      commit('SET_STATE', { action: 'loading', data: false })
      return { data: res.data.data, message: res.data.message }
    } catch (error) {
      commit('SET_STATE', { action: 'loading', data: false })
      const { message } = getMessageFromError(error)
      return Promise.reject({ message })
    }
  },
  /* -------------------------------------------------------------------------- */
  /*                        Proceed Booking                                     */
  /* -------------------------------------------------------------------------- */
  async proceedBooking({ commit }, data) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.post(`${PREFIX}/proceed-booking`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },
  /* -------------------------------------------------------------------------- */
  /*                        Update Booking                                      */
  /* -------------------------------------------------------------------------- */
  async assignDuty({ commit }, { bookingId, user_ids, notify = false }) {
    commit('SET_STATE', { action: 'loading', data: true })
    try {
      const res = await this.$http.put(`admin/gurudwara-service-booking/duty-assign/${bookingId}`, {
        user_ids: user_ids || [],
        notify: notify === true
      })
      commit('SET_STATE', { action: 'loading', data: false })
      return { data: res.data.data, message: res.data.message }
    } catch (error) {
      commit('SET_STATE', { action: 'loading', data: false })
      const { message } = getMessageFromError(error)
      return Promise.reject({ message })
    }
  },
  async updateBooking({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.put(`admin/gurudwara-service-booking/update/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },
  /* -------------------------------------------------------------------------- */
  /*                        Create Razorpay Order                               */
  /* -------------------------------------------------------------------------- */
  async createRazorpayOrder({ commit }, { bookingId, service_amount, platform_fee, net_receive_amount, total_amount }) {
    if (!featureFlags.enablePaymentGateway) {
      return Promise.reject({ message: 'Payment gateway is temporarily unavailable' })
    }
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.post(`admin/gurudwara-service-booking/create-razorpay-order/${bookingId}`, {
        service_amount,
        platform_fee,
        net_receive_amount,
        total_amount
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },
  /* -------------------------------------------------------------------------- */
  /*                        Send Payment Request                                */
  /* -------------------------------------------------------------------------- */
  async sendPaymentRequest({ commit }, { bookingId, service_amount, platform_fee, net_receive_amount, total_amount, order_id }) {
    if (!featureFlags.enablePaymentGateway) {
      return Promise.reject({ message: 'Payment gateway is temporarily unavailable' })
    }
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const payload = {
        service_amount,
        platform_fee,
        net_receive_amount,
        total_amount,
        // order_id
      }
      // Only include order_id if provided (for backward compatibility)
      if (order_id) {
        payload.order_id = order_id
      }
      const res = await this.$http.post(`admin/gurudwara-service-booking/send-payment-request/${bookingId}`, payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },
  /* -------------------------------------------------------------------------- */
  /*                        Toggle Slot Visibility                              */
  /* -------------------------------------------------------------------------- */
  async toggleSlotVisibility({ commit }, { gurudwara_service_id, date, start_time, end_time }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.post(`admin/gurudwara-service-booking/time-slots/toggle-visibility`, {
        gurudwara_service_id,
        date,
        start_time,
        end_time
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  }
}
